import { useContext, useEffect, useState } from 'react';
import { FaSun } from "react-icons/fa";
import { ThemeContext } from '../../contexts/ThemeContext';

// const getStoredTheme = () => localStorage.getItem('theme') || 'dark';

const ThemeSwitch = () => {
  // const [theme, setTheme] = useState(getStoredTheme);

  const { theme, setTheme } = useContext(ThemeContext);
  const [enabled, setEnabled] = useState(theme === 'dark');


  const handleThemeChange = () => {
    const newTheme = enabled ? 'light' : 'dark';
    setTheme(newTheme);
    setEnabled(!enabled);
  };

  return (
    <div className="flex items-end justify-center">
      <span className='pr-2'>Light</span>
      <button
        onClick={handleThemeChange}
        className={`relative inline-flex h-6 w-11 rounded-full border-2 transition-colors duration-200 ease-in-out 
          ${enabled ? 'bg-yellow-600' : 'bg-gray-400'}`}
      >
        <span className="sr-only">Toggle Theme</span>
        <span
          className={`absolute inset-y-0 left-0 flex h-5 w-5 items-center justify-center transform rounded-full bg-white shadow transition duration-200 ease-in-out 
            ${enabled ? 'translate-x-5' : 'translate-x-0'}`}
        >
          <FaSun className={`h-3 w-3 ${enabled ? 'text-yellow-600' : 'text-gray-400'}`} />
        </span>
      </button>
      <span className='pl-2'>Dark</span>
    </div>
  );
};

export default ThemeSwitch;
